import type { CSSProperties } from "react";

/**
 * `--g` ist die Gruppenfarbe. Alle Farbregeln der Zeitleiste leiten sich
 * daraus ab (heller Rand für „offen“, volle Füllung für „aktiv“ …), deshalb
 * steht sie als eigene Eigenschaft am Element und nicht als fertige Farbe.
 */
export function mitGruppenfarbe(farbe: string, rest: CSSProperties = {}): CSSProperties {
  return { ...rest, "--g": farbe } as CSSProperties;
}
